// Idle/configure state of the modal. The operator describes the reason,
// optionally opts into clean_volumes, and triggers the operation.

import { Alert, Button, Checkbox, Divider, Group, Stack, Text, Textarea } from '@mantine/core'
import { IconAlertCircle } from '@tabler/icons-react'
import { motion } from 'framer-motion'
import { ContainerCard } from './ContainerCard'
import { MOTION } from './tokens'

interface Props {
  containerName: string
  image?: string
  uptime?: string
  reason: string
  onReasonChange: (s: string) => void
  cleanVolumes: boolean
  onCleanVolumesChange: (b: boolean) => void
  onCancel: () => void
  onStart: () => void
  starting?: boolean
}

export function PreflightView({
  containerName,
  image,
  uptime,
  reason,
  onReasonChange,
  cleanVolumes,
  onCleanVolumesChange,
  onCancel,
  onStart,
  starting,
}: Props) {
  const canStart = reason.trim().length > 0 && !starting

  return (
    <motion.div
      key="preflight"
      initial={{ opacity: 0, y: 4 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -4 }}
      transition={MOTION.viewSwap}
    >
      <Stack gap="md">
        <ContainerCard
          containerName={containerName}
          image={image}
          uptime={uptime}
        />

        <Alert color="orange" variant="light" icon={<IconAlertCircle size={16} />}>
          O container será <strong>parado, removido</strong>, a imagem atualizada do
          registry e recriado com a mesma configuração.
        </Alert>

        <Textarea
          label="Motivo"
          placeholder="Descreva o motivo do restart (ex.: kafka travou, deploy quebrado…)"
          value={reason}
          onChange={e => onReasonChange(e.currentTarget.value)}
          minRows={2}
          autosize
          required
        />

        <Divider />

        <Checkbox
          label="Limpar volumes nomeados"
          description="Remove os volumes associados a este container. DADOS SERÃO PERDIDOS de forma irreversível."
          checked={cleanVolumes}
          onChange={e => onCleanVolumesChange(e.currentTarget.checked)}
          color="red"
        />
        {cleanVolumes && (
          <Alert color="red" variant="filled" icon={<IconAlertCircle size={16} />}>
            ATENÇÃO: os volumes deste container serão apagados permanentemente.
            Esta ação não pode ser desfeita.
          </Alert>
        )}

        <Group justify="flex-end" mt="sm">
          <Button variant="subtle" color="gray" onClick={onCancel} disabled={starting}>
            Cancelar
          </Button>
          <Button
            color={cleanVolumes ? 'red' : 'orange'}
            disabled={!canStart}
            loading={starting}
            onClick={onStart}
          >
            {cleanVolumes ? 'Hard Restart + Limpar Volumes' : 'Hard Restart'}
          </Button>
        </Group>
        <Text size="xs" c="dimmed" style={{ textAlign: 'right' }}>
          {starting ? 'Iniciando…' : 'Você pode acompanhar o progresso em tempo real.'}
        </Text>
      </Stack>
    </motion.div>
  )
}
